module.exports = __webpack_public_path__ + "img/视频场景_视频通话.d70e0f62.png";